import { render, staticRenderFns } from "./ResultsTable.vue?vue&type=template&id=606e3b7a&scoped=true&"
import script from "./ResultsTable.vue?vue&type=script&lang=js&"
export * from "./ResultsTable.vue?vue&type=script&lang=js&"
import style0 from "./ResultsTable.vue?vue&type=style&index=0&id=606e3b7a&lang=scss&scoped=true&"
import style1 from "./ResultsTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606e3b7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('606e3b7a')) {
      api.createRecord('606e3b7a', component.options)
    } else {
      api.reload('606e3b7a', component.options)
    }
    module.hot.accept("./ResultsTable.vue?vue&type=template&id=606e3b7a&scoped=true&", function () {
      api.rerender('606e3b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/contacts/ResultsTable.vue"
export default component.exports